import { Box, Text } from '@chakra-ui/core'
import BlocksPageBuilder from 'components/BlocksPageBuilder'
import GridContainer from 'components/GridContainer'
import GridItem from 'components/GridItem'
import HeadingWithColor from 'components/HeadingWithColor'
import NavigationListItemTitle from 'components/NavigationListItemTitle'
import NavigationListLink from 'components/NavigationListLink'
import News from 'components/News'
import {
  FRAGMENT_PAGE_BUILDER,
  QUERY_FOOTER_MENU,
  QUERY_MAIN_MENU,
  QUERY_ALERTS,
} from 'pages/[...uri]'
import React from 'react'
import NavigationListItemIntro from '../components/NavigationListItemIntro'
import BaseLayout from '../layouts/BaseLayout'
import {
  Campus,
  FooterMenu,
  MainImage,
  MainMenu,
  NavigationalSymbol,
  Entry,
} from '../types'
import { fetcher } from '../utils/cmsDataFetcher'
import constants from '../utils/constants'
import l10n from 'l10n'

export const GET_FRONT_PAGE_CONTENT = `
${FRAGMENT_PAGE_BUILDER}
query getFrontPageContent($site: [String]) {
  footerMenu:  ${QUERY_FOOTER_MENU}
  mainMenu: ${QUERY_MAIN_MENU}
  alerts: ${QUERY_ALERTS}
  entries(section: "pages", site: $site, level: 1, enabledForSite: true) {
    id
    title
    uri
    url
    ...on pages_service_Entry {
      intro
      navigationalSymbol {
        uid
        url
        height
        width
      }
    }
    ...on pages_list_Entry {
      intro
      navigationalSymbol {
        uid
        url
        height
        width
      }
    }
    ...on pages_pages_Entry {
      intro
      navigationalSymbol {
        uid
        url
        height
        width
      }
    }
  }
  entry(uri: "__home__", site: $site, enabledForSite: true) {
    ...on frontPage_frontPage_Entry {
      id
      uid
      title
      headingWithColor
      mainImage {
        uid
        title
        url
        height
        width
        ...on images_Asset {
          imageCaption
          imageOptimize {
            placeholderBox
          }
        }
      }
      pageBuilder {
        ...pageBuilder
      }
      newsFromCategory {
        id
      }
      numberOfNewsToDisplay
    }
  }
}`

const FrontPage = ({ data, site }: Props) => {
  return (
    <BaseLayout
      title="Norges arktiske studentsamskipnad"
      headerBackgroundColor="red.900"
      colorTheme="dark"
      footerMenu={data?.footerMenu}
      mainMenu={data?.mainMenu}
      alerts={data?.alerts}
    >
      <Box backgroundColor="brown.50">
        <Box backgroundColor="red.900" py={[16, 20]} mb={[8, 16]}>
          <GridContainer padding>
            <GridItem colStart={1} colSpan={11}>
              <HeadingWithColor>
                {data?.entry?.headingWithColor}
              </HeadingWithColor>
            </GridItem>
          </GridContainer>
          <GridContainer padding alignItems="start" rowGap={12} mt={[20, 24]}>
            <GridItem colStart={1} colSpan={11}>
              <Text color="red.50" fontSize={['sm', 'md']} fontWeight="bold">
                {l10n.ourServices}
              </Text>
            </GridItem>

            {data?.entries?.map((entry) => (
              <GridItem key={entry.id} colSpan={[12, 6, 4, 3]}>
                <NavigationListLink
                  href="/[...uri]"
                  url={entry.url}
                  icon={entry.navigationalSymbol?.[0]}
                >
                  <NavigationListItemTitle color="red.300">
                    {entry.title}
                  </NavigationListItemTitle>
                </NavigationListLink>
                <NavigationListItemIntro color="red.50">
                  {entry.intro}
                </NavigationListItemIntro>
              </GridItem>
            ))}
          </GridContainer>
        </Box>

        <BlocksPageBuilder blocks={data.entry?.pageBuilder} />

        {!!data?.entry?.newsFromCategory.length && (
          <News
            site={site}
            numberOfNewsToDisplay={data?.entry?.numberOfNewsToDisplay}
            pt={0}
            // For some reason I gotta do this here and not in News
            newsCategory={data?.entry?.newsFromCategory?.map((c) =>
              Number(c.id)
            )}
          />
        )}
      </Box>
    </BaseLayout>
  )
}

// export async function getServerSideProps() {
//   const site = constants.Sites.Norwegian
//   const data = await fetcher(GET_FRONT_PAGE_CONTENT, { site })
//   return { props: { data, site } }
// }

export async function getStaticProps() {
  const site = constants.Sites.Norwegian
  const data = await fetcher(GET_FRONT_PAGE_CONTENT, {
    site,
  })
  return { props: { data, site }, unstable_revalidate: 5 }
}

export type Props = {
  site: string
  data: {
    entry: Entry
    entries: [Entry]
    mainMenu?: MainMenu
    footerMenu?: FooterMenu
    alerts?: any
  }
}

export default FrontPage
